import Vue from 'vue';

export default class EventService extends Vue{
    public emit(name: string, event: any) {
        this.$emit(name, event);
    }

    public on(name: string, callBack: Function) {
        this.$on(name, (event: any) => {
            callBack(event);
        });
    }

    public off(name: string){
        this.$off(name);
    }
}

export const eventService = new EventService();